import { z } from 'zod'
import { ApiLocale, NotificationType } from '~library/enums'

/** 我的帳號 - 提醒事項 Schema */
export const myAccountRemindItemSchema = z.object({
  /** 提醒事項Id */
  id: z.string(),
  /** 釘選 */
  pin: z.boolean(),
  /** 是否已讀 */
  read: z.boolean(),
  /** 類型 */
  type: z.nativeEnum(NotificationType),
  /** 發佈日期 */
  releaseTime: z.string(),
  /** 主旨 */
  subject: z.string(),
  /** 內容 */
  content: z.string(),
  /** 語系 */
  lang: z.nativeEnum(ApiLocale)
})

/** 我的帳號 - 提醒事項 */
export interface MyAccountRemindItem
  extends z.infer<typeof myAccountRemindItemSchema> {}
